import { Role, UserProfileType } from "utils/saastypes";

type AuthorizationCapabilityInput = {
  isOrkesUser: boolean;
  currentUserRoles?: Role[];
  currentProfile?: UserProfileType;
  orkesOrganizationMember?: boolean;
};

/**
 * Mirrors the authorities assembled by UserDto.getGrantedAuthorities(). The organization-member
 * bit is supplied by /currentOrganization; profile-derived authorities stay live when the user
 * switches profile because currentProfile is refreshed separately.
 */
export function getAuthorizationCapabilities({
  isOrkesUser,
  currentUserRoles = [],
  currentProfile,
  orkesOrganizationMember = false,
}: AuthorizationCapabilityInput) {
  const hasAdminOrRootRole = [Role.COMPANY_ROOT, Role.COMPANY_ADMIN].some((r) =>
    currentUserRoles.includes(r)
  );
  const hasEngineeringProfile =
    isOrkesUser && currentProfile === UserProfileType.ENGINEERING;
  const hasGlobalBypass = orkesOrganizationMember || hasEngineeringProfile;
  const hasSupportOperationalAccess =
    isOrkesUser &&
    currentProfile === UserProfileType.CLOUD_SUPPORT_ENGINEER_WRITE;

  return {
    hasAdminOrRootRole,
    hasEngineeringProfile,
    hasGlobalBypass,
    hasSupportOperationalAccess,
    canManageEnvironment: hasAdminOrRootRole || hasGlobalBypass,
    canUseSupportOperations: hasGlobalBypass || hasSupportOperationalAccess,
  };
}
